import { useCallback, useContext } from "react"
import { getAccuracyStatsFetch, getCorrectWordsPerMinuteStatsFetch, getFactoredAccuracyStatsFetch, getFluencyStatsFetch, getReadingFluencyStatsFetch } from "store/middlewares/rating.crud"
import { NormalizerContext } from "../NormalizerContext"
import { queryClient as qc } from 'keys'
import { useQueryClient } from "@tanstack/react-query"

export const checkTypes = [
    { id: "words_per_minute", name: "קצב", barItemWidth: 5.5, queryFn: getFluencyStatsFetch, queryKey: qc.fluencyStats },
    { id: "correct_words_per_minute", name: "מספר מילים נכונות לדקה", barItemWidth: 5.5, queryFn: getCorrectWordsPerMinuteStatsFetch, queryKey: qc.correctWordsPerMinute },
    { id: "percent_accuracy", name: "דיוק", percent: true, barItemWidth: 20, queryFn: getAccuracyStatsFetch, queryKey: qc.accuracyStats },
    { id: "factored_percent_accuracy", name: "דיוק משוקלל", percent: true, barItemWidth: 20, queryFn: getFactoredAccuracyStatsFetch, queryKey: qc.factoredAccuracyStats },
    { id: "fluency", name: "רציפות קריאה", percent: true, barItemWidth: 50, queryFn: getReadingFluencyStatsFetch, queryKey: qc.readingFluencyStats }
]

const useSelectCheckType = () => {
    const { setLoadingData, checkType, setCheckType } = useContext(NormalizerContext)
    const queryClient = useQueryClient()

    const handleChangeCheckType = useCallback((val) => {
        if (checkType)
            queryClient.removeQueries({ queryKey: [checkType.queryKey] })
        setCheckType(val)
        setLoadingData(true)
    }, [checkType])

    const selectCheckType = {
        options: checkTypes,
        onChange: handleChangeCheckType,
        input: {
            value: checkType,
        },
        placeholder: "תחום הבדיקה",
        border: true,
        width: 110,
        component: "autoComplete"
    }

    return selectCheckType
}

export default useSelectCheckType